module.exports = __webpack_public_path__ + "static/media/layers-purple.7acf0886.svg";